import React, { Component } from "react";
import {
  Paper,
  TextField,
  Subheader,
  Divider,
  FlatButton,
  AutoComplete,
  MenuItem,
} from "material-ui";
import Formsy from "formsy-react";
import {
  FormsyText,
  FormsyAutoComplete,
  FormsyRadioGroup,
  FormsyRadio,
  FormsySelect,
  FormsyCheckbox,
} from "formsy-material-ui/lib";
import Loading from "../Loading";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import FormsyDate from "../forms/formComponents/FormsyDate";
import formatDate from "../../../utils/formatDate";
import CircularProgress from "material-ui/CircularProgress";

export default class ClientEditor extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isComparing: false,
      fields: [
        "salutation__c",
        "name",
        "billingstreet",
        "billingcity",
        "billingstate",
        "billingpostalcode",
        "phone",
        "primary_email__c",
        "first_name__c",
        "middle_name__c",
        "last_name__c",
      ],
      compare: {},
      styles: {
        centerStyle: {
          marginBottom: "1em",
          marginLeft: "auto",
          marginRight: "auto",
          width: "50%",
        },
        listStyle: {
          marginTop: "0em",
          paddingTop: "0em",
          paddingLeft: "1em",
          paddingRight: "1em",
        },
        listPaperStyle: {
          marginBottom: "1em",
        },
        listItemStyle: {
          paddingLeft: "0em",
        },
      },
    };

    this.submitForm = this.submitForm.bind(this);
  }

  componentWillMount() {
    this.props.authFetchDetails(
      "clients/clientUpdates/" + this.props.params._id,
      this.props.token.jwt,
    );
  }

  submitForm(data) {
    // console.log(JSON.stringify(data));
    // let url = '/api/clients/updateClient';
    let url = "/api/clients/createClientUpdate";
    let options = {
      method: "PUT",
      headers: {
        token: this.props.token.jwt,
        "content-type": "application/json",
      },
      body: JSON.stringify(data),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        if (json.message === "pending") {
          alert(
            `Your update has been submitted, your changes won't take affect until they are approved.`,
          );
        } else {
          this.props.authFetchDetails(
            "clients/" + this.props.params._id,
            this.props.token.jwt,
          );
        }
      });
  }

  notifyFormError(data) {
    alert("Missing Data: check that all fields are filled");
    console.error("Form error:", data);
  }

  compareClient(clientId) {
    this.setState({ isComparing: true });
    let url = "/api/clients/compareClient";
    let options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        token: this.props.token.jwt,
      },
      body: JSON.stringify({ clientId: clientId, fields: this.state.fields }),
    };
    fetch(url, options)
      .then((res) => {
        if (res.status >= 200 && res.status < 300) return res.json();
      })
      .then((json) => {
        this.setState({ isComparing: false });
        if (Object.keys(json).length > 0) {
          this.setState({ compare: json });
          let errors = {};
          Object.keys(json).map((key) => {
            errors[key] = "Field does not match CCH";
          });
          this.refs.form.updateInputsWithError(errors);
        } else {
          alert("All Fields Match CCH");
        }
      });
  }

  render() {
    if (this.props.isLoading) {
      return (
        <div className="container">
          <center>
            <Loading color={this.props.appbar.color} />
          </center>
        </div>
      );
    } else {
      let { centerStyle } = this.state.styles;
      let compare = this.state.compare;
      let client = this.props.details;

      return (
        <div>
          <Paper
            className="container"
            zDepth={2}
            style={{
              marginTop: "2em",
              paddingTop: "1em",
              paddingBottom: "1em",
            }}
          >
            <div style={centerStyle}>
              <h1 style={{ marginBottom: "1em" }}>Pending Record Update</h1>
            </div>
            <Divider />
            {/*<Subheader>Record Actions</Subheader>
						<div style={centerStyle}>
							<FlatButton
								style={{marginTop: '2em', marginBottom: '1em'}}
								label={ this.state.isComparing ? <CircularProgress color={this.props.color || '#424242'} size={25} thickness={5} /> : 'Compare to CCH' }
								onClick={this.compareClient.bind(this, client.uid__c)}
							/>
						</div>
						<Divider />
						<Subheader>Record Info</Subheader>
						<div style={centerStyle}>
							{`Salesforce Write Status: ${client._hc_lastop}`}
						</div>*/}
            <Formsy.Form
              ref="form"
              onValidSubmit={this.submitForm}
              onInvalidSubmit={this.notifyFormError}
            >
              <Divider />
              <Subheader>Submission Info</Subheader>
              <div style={centerStyle}>
                <FormsyDate
                  fullWidth
                  disabled
                  formatDate={(date) => formatDate(date)}
                  name="createdDate"
                  floatingLabelText="Date Submitted"
                  value={new Date(client.createdAt)}
                />
                <FormsyText
                  fullWidth
                  readOnly
                  name="submitter"
                  floatingLabelText="Submitter"
                  value={client.createdby.name}
                />
                <FormsyText
                  fullWidth
                  multiLine
                  readOnly
                  name="comment"
                  floatingLabelText="Comment"
                  value={client.comment}
                />
              </div>
              <Divider />
              <Subheader>Client Info</Subheader>
              <div style={centerStyle}>
                <FormsyText
                  fullWidth
                  readOnly
                  name="uid__c"
                  floatingLabelText="Client ID"
                  value={client.uid__c}
                />
                <FormsyText
                  fullWidth
                  readOnly
                  name="status__c"
                  floatingLabelText="Status"
                  value={client.status__c}
                />
                <FormsyText
                  readOnly
                  style={{ display: "none" }}
                  name="id"
                  floatingLabelText="Bookshelf ID"
                  value={client.id}
                />
                <FormsyText
                  readOnly
                  style={{ display: "none" }}
                  name="_id"
                  floatingLabelText="Mongo ID"
                  value={client._id}
                />
              </div>
              <Divider />
              <Subheader>Client Name</Subheader>
              <div style={centerStyle}>
                {"salutation__c" in compare && (
                  <FormsyText
                    readOnly
                    name="comparesalutation__c"
                    floatingLabelText="CCH Salutation"
                    value={compare.salutation__c}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="salutation__c"
                  floatingLabelText="Salutation"
                  value={client.salutation__c}
                />
                {"name" in compare && (
                  <FormsyText
                    readOnly
                    name="comparename"
                    floatingLabelText="CCH Full Name"
                    value={compare.name}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="name"
                  floatingLabelText="Full Name"
                  value={client.name}
                />
                {"first_name__c" in compare && (
                  <FormsyText
                    readOnly
                    name="comparefirst_name__c"
                    floatingLabelText="CCH First Name"
                    value={compare.first_name__c}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="first_name__c"
                  floatingLabelText="First Name"
                  value={client.first_name__c}
                />
                {"middle_name__c" in compare && (
                  <FormsyText
                    readOnly
                    name="comparemiddle_name__c"
                    floatingLabelText="CCH Middle Name"
                    value={compare.middle_name__c}
                  />
                )}
                <FormsyText
                  fullWidth
                  name="middle_name__c"
                  floatingLabelText="Middle Name"
                  value={client.middle_name__c}
                />
                {"last_name__c" in compare && (
                  <FormsyText
                    readOnly
                    name="comparelast_name__c"
                    floatingLabelText="CCH Last Name"
                    value={compare.last_name__c}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="last_name__c"
                  floatingLabelText="Last Name"
                  value={client.last_name__c}
                />
              </div>
              <Divider />
              <Subheader>Mailing Address</Subheader>
              <div style={centerStyle}>
                {"billingstreet" in compare && (
                  <FormsyText
                    readOnly
                    name="comparebillingstreet"
                    floatingLabelText="CCH Street"
                    value={compare.billingstreet}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="billingstreet"
                  floatingLabelText="Street"
                  value={client.billingstreet}
                />
                {"billingcity" in compare && (
                  <FormsyText
                    readOnly
                    name="comparebillingcity"
                    floatingLabelText="CCH City"
                    value={compare.billingcity}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="billingcity"
                  floatingLabelText="City"
                  value={client.billingcity}
                />
                {"billingstate" in compare && (
                  <FormsyText
                    readOnly
                    name="comparebillingstate"
                    floatingLabelText="CCH State"
                    value={compare.billingstate}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="billingstate"
                  floatingLabelText="State"
                  value={client.billingstate}
                />
                {"billingpostalcode" in compare && (
                  <FormsyText
                    readOnly
                    name="comparebillingpostalcode"
                    floatingLabelText="ZIP Code"
                    value={compare.billingpostalcode}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="billingpostalcode"
                  floatingLabelText="ZIP Code"
                  value={client.billingpostalcode}
                />
              </div>
              <Divider />
              <Subheader>Contact Info</Subheader>
              <div style={centerStyle}>
                {"primary_email__c" in compare && (
                  <FormsyText
                    readOnly
                    name="compareprimary_email__c"
                    floatingLabelText="CCH Email Address"
                    value={compare.primary_email__c}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="primary_email__c"
                  floatingLabelText="Email Address"
                  value={client.primary_email__c}
                />
                {"phone" in compare && (
                  <FormsyText
                    readOnly
                    name="comparephone"
                    floatingLabelText="CCH Phone Number"
                    value={compare.phone}
                  />
                )}
                <FormsyText
                  required
                  fullWidth
                  name="phone"
                  floatingLabelText="Phone Number"
                  value={client.phone}
                />
                <FormsySelect
                  required
                  fullWidth
                  name="paper_only__c"
                  floatingLabelText="Paper Only"
                  value={client.paper_only__c}
                >
                  <MenuItem key="true" primaryText="True" value={true} />
                  <MenuItem key="fale" primaryText="False" value={false} />
                </FormsySelect>
              </div>
              <Divider />
              <Subheader>Tax Info</Subheader>
              <div style={centerStyle}>
                <FormsyText
                  required
                  fullWidth
                  name="return_type__c"
                  floatingLabelText="Return Type"
                  value={client.return_type__c}
                />
                <FormsyText
                  required
                  fullWidth
                  name="record_type__c"
                  floatingLabelText="Record Type"
                  value={client.record_type__c}
                />
                <FormsyText
                  required
                  fullWidth
                  name="year_end__c"
                  floatingLabelText="Year End"
                  value={client.year_end__c}
                />
              </div>
              <Divider />
              {/*<div style={centerStyle}>
							<div className="col-sm-6">
								<FlatButton
									backgroundColor='#A5D6A7'
									hoverColor='#81C784'
									style={{marginTop: '2em', marginBottom: '1em'}}
									label='Save'
									type='submit'
								/>
							</div>
							<div className="col-sm-6">
								<FlatButton
									backgroundColor='#E0E0E0'
									hoverColor='#BDBDBD'
									style={{marginTop: '2em', marginBottom: '1em'}}
									label='Cancel'
								/>
							</div>
						</div>*/}
            </Formsy.Form>
            <br />
          </Paper>
        </div>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./app/components/clients/ProcessClientUpdate.js